import { useEffect, useState } from "react";
import Header from "../components/Header";
import ImageUpload from "../components/ImageUpload";
import DetectionResult from "../components/DetectionResult";
import LoadingOverlay from "../ui/LoadingOverlay";
import MoonLoader from "react-spinners/MoonLoader";
import { useSelector, useDispatch } from "react-redux";
import { setUploadedImage, setDetectionImage, setInferenceTime } from "../features/detectSlice";

function ImageDetection() {
  const dispatch = useDispatch();
  const { isLoading, message } = useSelector((state) => state.model);
  const [llmMessage, setLlmMessage] = useState("");
  const [llmLoading, setLlmLoading] = useState(false);
  
  useEffect(() => {
    dispatch(setUploadedImage(null));
    dispatch(setDetectionImage(null));
    dispatch(setInferenceTime(0));
  }, [dispatch]); //setInferenceTime,setUploadedImage,setDetectionImage
 
  return (
    <>
      <Header />
      <LoadingOverlay isVisible={isLoading} message={message}>
        <MoonLoader color="#00BFFF" size={50} />
      </LoadingOverlay>
      <div className="pageContent">
        <ImageUpload setLlmMessage={setLlmMessage} setLlmLoading={setLlmLoading}/>
        <DetectionResult llmMessage={llmMessage} llmLoading={llmLoading}/>
      </div>
    </>
  );
}

export default ImageDetection;
